/* eslint-disable max-len */
import React from 'react';

export default function PhoneCircle() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" className="svg phone-circle" width="26" height="26" viewBox="0 0 25.27 25.27">
			<g data-name="Layer 1">
				<path d="M12.64 25.27a12.64 12.64 0 1 1 12.63-12.63 12.65 12.65 0 0 1-12.63 12.63zm0-23.27a10.64 10.64 0 1 0 10.63 10.64A10.65 10.65 0 0 0 12.64 2z" />
				<path d="M14.87 20.55a5 5 0 0 1-2.8-1 4.91 4.91 0 0 1-.56-.44 14 14 0 0 1-3-4.43l-.09-.18a10.69 10.69 0 0 1-1.36-5.79 4.38 4.38 0 0 1 2.7-3.93 4.58 4.58 0 0 1 2.77-.15 1.57 1.57 0 0 1 1.25 1.47l.13 2.9a1.52 1.52 0 0 1-.91 1.49l-.36.17A36.25 36.25 0 0 0 14.22 14l.36-.17a1.52 1.52 0 0 1 1.69.27l2.15 2a1.57 1.57 0 0 1 .31 1.9 4.61 4.61 0 0 1-1.91 2 4.58 4.58 0 0 1-1.95.55zM11.24 6.49a1.59 1.59 0 0 0-.64.11A2.44 2.44 0 0 0 9 8.95a9 9 0 0 0 1.23 4.71l.08.17a12.19 12.19 0 0 0 2.5 3.82 2.78 2.78 0 0 0 .33.26 2.44 2.44 0 0 0 2.8.34 2.32 2.32 0 0 0 .82-.87l-1.67-1.55-.45.21a1.57 1.57 0 0 1-2-.68 38.24 38.24 0 0 1-2-4.35 1.57 1.57 0 0 1 .8-2l.45-.21-.1-2.28a3.92 3.92 0 0 0-.55-.03zm3.66 9.13zm-3.26-6.5zm.54-.45z" />
			</g>
		</svg>
	);
}
